<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__header__start -->

<!-- #endregion customCode: page-component-html__header__start -->

<!-- Container: Main Container -->
<div class="rappider-container main-container col-12">
  <!-- Container: Container 2 -->
  <div class="rappider-container container-2 col-12 p-0 m-0">
    <!-- Container: Container 3 -->
    <div class="rappider-container container-3 col-10 p-0 m-0">
      <!-- Container: Container 4 -->
      <div
        class="rappider-container container-4 col-12 navbar-1-height p-0 hidden-mw480"
      >
        <div class="rappider-component">
          <!-- Component: Text 1 -->
          <rappider-text
            [textMode]="text_1.textMode"
            [text]="text_1.text"
            [content]="text_1.content"
            [typography]="text_1.typography"
            [colorSettings]="text_1.colorSettings"
          >
          </rappider-text>
        </div>

        <!-- Container: Container 5 -->
        <div class="rappider-container container-5 col-8 p-0 navbar-1-height">
          <div class="rappider-component">
            <!-- Component: Button 2 -->
            <rappider-button
              [text]="button_2.text"
              [type]="button_2.type"
              [shape]="button_2.shape"
              [size]="button_2.size"
              [colorType]="button_2.colorType"
              [icon]="button_2.icon"
              [iconPlacement]="button_2.iconPlacement"
              [transparent]="button_2.transparent"
              [loading]="button_2.loading"
              [block]="button_2.block"
              [disabled]="button_2.disabled"
              [key]="button_2.key"
              [emitWithoutPopconfirm]="button_2.emitWithoutPopconfirm"
              [popconfirmTitle]="button_2.popconfirmTitle"
              [borderSettings]="button_2.borderSettings"
              [marginSettings]="button_2.marginSettings"
              [paddingSettings]="button_2.paddingSettings"
              [shadowSettings]="button_2.shadowSettings"
              [customColorSettings]="button_2.customColorSettings"
              [customSizeSettings]="button_2.customSizeSettings"
            >
            </rappider-button>
          </div>

          <!-- Container: Container 6 -->
          <div class="rappider-container container-6 col-1 p-0">
            <div class="rappider-component">
              <!-- Component: Divider 3 -->
              <rappider-divider
                [style]="divider_3.style"
                [type]="divider_3.type"
                [text]="divider_3.text"
                [textPlacement]="divider_3.textPlacement"
                [dividerWidth]="divider_3.dividerWidth"
                [dividerColor]="divider_3.dividerColor"
              >
              </rappider-divider>
            </div>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 4 -->
            <rappider-button
              [text]="button_4.text"
              [type]="button_4.type"
              [shape]="button_4.shape"
              [size]="button_4.size"
              [colorType]="button_4.colorType"
              [icon]="button_4.icon"
              [iconPlacement]="button_4.iconPlacement"
              [transparent]="button_4.transparent"
              [loading]="button_4.loading"
              [block]="button_4.block"
              [disabled]="button_4.disabled"
              [key]="button_4.key"
              [emitWithoutPopconfirm]="button_4.emitWithoutPopconfirm"
              [popconfirmTitle]="button_4.popconfirmTitle"
              [borderSettings]="button_4.borderSettings"
              [marginSettings]="button_4.marginSettings"
              [paddingSettings]="button_4.paddingSettings"
              [shadowSettings]="button_4.shadowSettings"
              [customColorSettings]="button_4.customColorSettings"
              [customSizeSettings]="button_4.customSizeSettings"
            >
            </rappider-button>
          </div>

          <!-- Container: Container 7 -->
          <div class="rappider-container container-7 col-1 p-0">
            <div class="rappider-component">
              <!-- Component: Divider 5 -->
              <rappider-divider
                [style]="divider_5.style"
                [type]="divider_5.type"
                [text]="divider_5.text"
                [textPlacement]="divider_5.textPlacement"
                [dividerWidth]="divider_5.dividerWidth"
                [dividerColor]="divider_5.dividerColor"
              >
              </rappider-divider>
            </div>
          </div>

          <div class="rappider-component">
            <!-- Component: Dropdown Menu 6 -->
            <rappider-dropdown-menu
              [icon]="dropdownMenu_6.icon"
              [placement]="dropdownMenu_6.placement"
              [triggerType]="dropdownMenu_6.triggerType"
              [items]="dropdownMenu_6.items"
              [label]="dropdownMenu_6.label"
              [labelMode]="dropdownMenu_6.labelMode"
            >
            </rappider-dropdown-menu>
          </div>

          <!-- Container: Container 8 -->
          <div class="rappider-container container-8 col-1 p-0">
            <div class="rappider-component">
              <!-- Component: Divider 7 -->
              <rappider-divider
                [style]="divider_7.style"
                [type]="divider_7.type"
                [text]="divider_7.text"
                [textPlacement]="divider_7.textPlacement"
                [dividerWidth]="divider_7.dividerWidth"
                [dividerColor]="divider_7.dividerColor"
              >
              </rappider-divider>
            </div>
          </div>

          <div class="rappider-component">
            <!-- Component: Icon 8 -->
            <rappider-icon
              [name]="icon_8.name"
              [color]="icon_8.color"
              [size]="icon_8.size"
              [type]="icon_8.type"
              [theme]="icon_8.theme"
              [animation]="icon_8.animation"
              [style]="icon_8.style"
              [secondColor]="icon_8.secondColor"
            >
            </rappider-icon>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 9 -->
            <rappider-button
              [text]="button_9.text"
              [type]="button_9.type"
              [shape]="button_9.shape"
              [size]="button_9.size"
              [colorType]="button_9.colorType"
              [icon]="button_9.icon"
              [iconPlacement]="button_9.iconPlacement"
              [transparent]="button_9.transparent"
              [loading]="button_9.loading"
              [block]="button_9.block"
              [disabled]="button_9.disabled"
              [key]="button_9.key"
              [emitWithoutPopconfirm]="button_9.emitWithoutPopconfirm"
              [popconfirmTitle]="button_9.popconfirmTitle"
              [borderSettings]="button_9.borderSettings"
              [marginSettings]="button_9.marginSettings"
              [paddingSettings]="button_9.paddingSettings"
              [shadowSettings]="button_9.shadowSettings"
              [customColorSettings]="button_9.customColorSettings"
              [customSizeSettings]="button_9.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 10 -->
            <rappider-button
              [text]="button_10.text"
              [type]="button_10.type"
              [shape]="button_10.shape"
              [size]="button_10.size"
              [colorType]="button_10.colorType"
              [icon]="button_10.icon"
              [iconPlacement]="button_10.iconPlacement"
              [transparent]="button_10.transparent"
              [loading]="button_10.loading"
              [block]="button_10.block"
              [disabled]="button_10.disabled"
              [key]="button_10.key"
              [emitWithoutPopconfirm]="button_10.emitWithoutPopconfirm"
              [popconfirmTitle]="button_10.popconfirmTitle"
              [borderSettings]="button_10.borderSettings"
              [marginSettings]="button_10.marginSettings"
              [paddingSettings]="button_10.paddingSettings"
              [shadowSettings]="button_10.shadowSettings"
              [customColorSettings]="button_10.customColorSettings"
              [customSizeSettings]="button_10.customSizeSettings"
            >
            </rappider-button>
          </div>
        </div>
      </div>

      <!-- Container: Container 9 -->
      <div
        class="rappider-container container-9 col-12 hidden-mw480 p-0 navbar-1-height"
      >
        <!-- Container: Container 10 -->
        <div
          class="rappider-container container-10 col-3 container-spacing-settings p-0"
        >
          <div class="rappider-component">
            <!-- Component: Image 11 -->
            <rappider-image
              [source]="image_11.source"
              [alternateText]="image_11.alternateText"
              [placeholder]="image_11.placeholder"
              [disablePreview]="image_11.disablePreview"
              [borderSettings]="image_11.borderSettings"
              [shadowSettings]="image_11.shadowSettings"
              [paddingSettings]="image_11.paddingSettings"
              [marginSettings]="image_11.marginSettings"
              [customSizeSettings]="image_11.customSizeSettings"
            >
            </rappider-image>
          </div>
        </div>

        <!-- Container: Container 11 -->
        <div
          class="rappider-container container-11 col-6 container-spacing-settings"
        >
          <div class="rappider-component select-height">
            <!-- Component: Select 12 -->
            <rappider-select
              [grouppedOptions]="select_12.grouppedOptions"
              [placeholder]="select_12.placeholder"
              [invalidConfigText]="select_12.invalidConfigText"
              [disabled]="select_12.disabled"
              [buttons]="select_12.buttons"
              [dropdownMatchSelectWidth]="select_12.dropdownMatchSelectWidth"
              [dropdownClassName]="select_12.dropdownClassName"
              [cssStyle]="select_12.cssStyle"
              [cssClass]="select_12.cssClass"
              [borderSettings]="select_12.borderSettings"
              [sizeSettings]="select_12.sizeSettings"
              [colorSettings]="select_12.colorSettings"
              [boxShadowSettings]="select_12.boxShadowSettings"
              [paddingSettings]="select_12.paddingSettings"
              [marginSettings]="select_12.marginSettings"
              [size]="select_12.size"
              [settings]="select_12.settings"
              [options]="select_12.options"
            >
            </rappider-select>
          </div>

          <div class="rappider-component input-button input-settings">
            <!-- Component: Input Group 13 -->
            <rappider-input-group
              [prefixIcon]="inputGroup_13.prefixIcon"
              [suffixIcon]="inputGroup_13.suffixIcon"
              [prefixButton]="inputGroup_13.prefixButton"
              [suffixButton]="inputGroup_13.suffixButton"
              [textbox]="inputGroup_13.textbox"
              [prefixText]="inputGroup_13.prefixText"
              [suffixText]="inputGroup_13.suffixText"
            >
            </rappider-input-group>
          </div>
        </div>

        <!-- Container: Container 12 -->
        <div
          class="rappider-container container-12 col-2 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Icon 14 -->
            <rappider-icon
              [name]="icon_14.name"
              [color]="icon_14.color"
              [size]="icon_14.size"
              [type]="icon_14.type"
              [theme]="icon_14.theme"
              [animation]="icon_14.animation"
              [style]="icon_14.style"
              [secondColor]="icon_14.secondColor"
            >
            </rappider-icon>
          </div>

          <div class="rappider-component">
            <!-- Component: Text 15 -->
            <rappider-text
              [textMode]="text_15.textMode"
              [text]="text_15.text"
              [content]="text_15.content"
              [typography]="text_15.typography"
              [colorSettings]="text_15.colorSettings"
            >
            </rappider-text>
          </div>

          <div class="rappider-component">
            <!-- Component: Dropdown Menu 16 -->
            <rappider-dropdown-menu
              [icon]="dropdownMenu_16.icon"
              [placement]="dropdownMenu_16.placement"
              [triggerType]="dropdownMenu_16.triggerType"
              [items]="dropdownMenu_16.items"
              [label]="dropdownMenu_16.label"
              [labelMode]="dropdownMenu_16.labelMode"
            >
            </rappider-dropdown-menu>
          </div>
        </div>
      </div>

      <!-- Container: Container 13 -->
      <div
        class="rappider-container container-13 col-12 container-spacing-settings hidden-mw480 navbar-2-height"
      >
        <div class="rappider-component">
          <!-- Component: Button 17 -->
          <rappider-button
            [text]="button_17.text"
            [type]="button_17.type"
            [shape]="button_17.shape"
            [size]="button_17.size"
            [colorType]="button_17.colorType"
            [icon]="button_17.icon"
            [iconPlacement]="button_17.iconPlacement"
            [transparent]="button_17.transparent"
            [loading]="button_17.loading"
            [block]="button_17.block"
            [disabled]="button_17.disabled"
            [key]="button_17.key"
            [emitWithoutPopconfirm]="button_17.emitWithoutPopconfirm"
            [popconfirmTitle]="button_17.popconfirmTitle"
            [borderSettings]="button_17.borderSettings"
            [marginSettings]="button_17.marginSettings"
            [paddingSettings]="button_17.paddingSettings"
            [shadowSettings]="button_17.shadowSettings"
            [customColorSettings]="button_17.customColorSettings"
            [customSizeSettings]="button_17.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 18 -->
          <rappider-button
            [text]="button_18.text"
            [type]="button_18.type"
            [shape]="button_18.shape"
            [size]="button_18.size"
            [colorType]="button_18.colorType"
            [icon]="button_18.icon"
            [iconPlacement]="button_18.iconPlacement"
            [transparent]="button_18.transparent"
            [loading]="button_18.loading"
            [block]="button_18.block"
            [disabled]="button_18.disabled"
            [key]="button_18.key"
            [emitWithoutPopconfirm]="button_18.emitWithoutPopconfirm"
            [popconfirmTitle]="button_18.popconfirmTitle"
            [borderSettings]="button_18.borderSettings"
            [marginSettings]="button_18.marginSettings"
            [paddingSettings]="button_18.paddingSettings"
            [shadowSettings]="button_18.shadowSettings"
            [customColorSettings]="button_18.customColorSettings"
            [customSizeSettings]="button_18.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 19 -->
          <rappider-button
            [text]="button_19.text"
            [type]="button_19.type"
            [shape]="button_19.shape"
            [size]="button_19.size"
            [colorType]="button_19.colorType"
            [icon]="button_19.icon"
            [iconPlacement]="button_19.iconPlacement"
            [transparent]="button_19.transparent"
            [loading]="button_19.loading"
            [block]="button_19.block"
            [disabled]="button_19.disabled"
            [key]="button_19.key"
            [emitWithoutPopconfirm]="button_19.emitWithoutPopconfirm"
            [popconfirmTitle]="button_19.popconfirmTitle"
            [borderSettings]="button_19.borderSettings"
            [marginSettings]="button_19.marginSettings"
            [paddingSettings]="button_19.paddingSettings"
            [shadowSettings]="button_19.shadowSettings"
            [customColorSettings]="button_19.customColorSettings"
            [customSizeSettings]="button_19.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 20 -->
          <rappider-button
            [text]="button_20.text"
            [type]="button_20.type"
            [shape]="button_20.shape"
            [size]="button_20.size"
            [colorType]="button_20.colorType"
            [icon]="button_20.icon"
            [iconPlacement]="button_20.iconPlacement"
            [transparent]="button_20.transparent"
            [loading]="button_20.loading"
            [block]="button_20.block"
            [disabled]="button_20.disabled"
            [key]="button_20.key"
            [emitWithoutPopconfirm]="button_20.emitWithoutPopconfirm"
            [popconfirmTitle]="button_20.popconfirmTitle"
            [borderSettings]="button_20.borderSettings"
            [marginSettings]="button_20.marginSettings"
            [paddingSettings]="button_20.paddingSettings"
            [shadowSettings]="button_20.shadowSettings"
            [customColorSettings]="button_20.customColorSettings"
            [customSizeSettings]="button_20.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 21 -->
          <rappider-button
            [text]="button_21.text"
            [type]="button_21.type"
            [shape]="button_21.shape"
            [size]="button_21.size"
            [colorType]="button_21.colorType"
            [icon]="button_21.icon"
            [iconPlacement]="button_21.iconPlacement"
            [transparent]="button_21.transparent"
            [loading]="button_21.loading"
            [block]="button_21.block"
            [disabled]="button_21.disabled"
            [key]="button_21.key"
            [emitWithoutPopconfirm]="button_21.emitWithoutPopconfirm"
            [popconfirmTitle]="button_21.popconfirmTitle"
            [borderSettings]="button_21.borderSettings"
            [marginSettings]="button_21.marginSettings"
            [paddingSettings]="button_21.paddingSettings"
            [shadowSettings]="button_21.shadowSettings"
            [customColorSettings]="button_21.customColorSettings"
            [customSizeSettings]="button_21.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 22 -->
          <rappider-button
            [text]="button_22.text"
            [type]="button_22.type"
            [shape]="button_22.shape"
            [size]="button_22.size"
            [colorType]="button_22.colorType"
            [icon]="button_22.icon"
            [iconPlacement]="button_22.iconPlacement"
            [transparent]="button_22.transparent"
            [loading]="button_22.loading"
            [block]="button_22.block"
            [disabled]="button_22.disabled"
            [key]="button_22.key"
            [emitWithoutPopconfirm]="button_22.emitWithoutPopconfirm"
            [popconfirmTitle]="button_22.popconfirmTitle"
            [borderSettings]="button_22.borderSettings"
            [marginSettings]="button_22.marginSettings"
            [paddingSettings]="button_22.paddingSettings"
            [shadowSettings]="button_22.shadowSettings"
            [customColorSettings]="button_22.customColorSettings"
            [customSizeSettings]="button_22.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 23 -->
          <rappider-button
            [text]="button_23.text"
            [type]="button_23.type"
            [shape]="button_23.shape"
            [size]="button_23.size"
            [colorType]="button_23.colorType"
            [icon]="button_23.icon"
            [iconPlacement]="button_23.iconPlacement"
            [transparent]="button_23.transparent"
            [loading]="button_23.loading"
            [block]="button_23.block"
            [disabled]="button_23.disabled"
            [key]="button_23.key"
            [emitWithoutPopconfirm]="button_23.emitWithoutPopconfirm"
            [popconfirmTitle]="button_23.popconfirmTitle"
            [borderSettings]="button_23.borderSettings"
            [marginSettings]="button_23.marginSettings"
            [paddingSettings]="button_23.paddingSettings"
            [shadowSettings]="button_23.shadowSettings"
            [customColorSettings]="button_23.customColorSettings"
            [customSizeSettings]="button_23.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 24 -->
          <rappider-button
            [text]="button_24.text"
            [type]="button_24.type"
            [shape]="button_24.shape"
            [size]="button_24.size"
            [colorType]="button_24.colorType"
            [icon]="button_24.icon"
            [iconPlacement]="button_24.iconPlacement"
            [transparent]="button_24.transparent"
            [loading]="button_24.loading"
            [block]="button_24.block"
            [disabled]="button_24.disabled"
            [key]="button_24.key"
            [emitWithoutPopconfirm]="button_24.emitWithoutPopconfirm"
            [popconfirmTitle]="button_24.popconfirmTitle"
            [borderSettings]="button_24.borderSettings"
            [marginSettings]="button_24.marginSettings"
            [paddingSettings]="button_24.paddingSettings"
            [shadowSettings]="button_24.shadowSettings"
            [customColorSettings]="button_24.customColorSettings"
            [customSizeSettings]="button_24.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>

      <!-- Container: Container 14 -->
      <div
        class="rappider-container container-14 col-12 container-spacing-settings mobile-navbar-bg mobile-navbar-settings"
      >
        <!-- Container: Container 15 -->
        <div
          class="rappider-container container-15 col-12 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Image 25 -->
            <rappider-image
              [source]="image_25.source"
              [alternateText]="image_25.alternateText"
              [placeholder]="image_25.placeholder"
              [disablePreview]="image_25.disablePreview"
              [borderSettings]="image_25.borderSettings"
              [shadowSettings]="image_25.shadowSettings"
              [paddingSettings]="image_25.paddingSettings"
              [marginSettings]="image_25.marginSettings"
              [customSizeSettings]="image_25.customSizeSettings"
            >
            </rappider-image>
          </div>

          <!-- Container: Container 16 -->
          <div
            class="rappider-container container-16 col-1 container-spacing-settings"
          >
            <div class="rappider-component">
              <!-- Component: Cart Preview  26 -->
              <rappider-cart-preview
                [cartItem]="cartPreview_26.cartItem"
                [footer]="cartPreview_26.footer"
                [footerContent]="cartPreview_26.footerContent"
                [buttons]="cartPreview_26.buttons"
                [dropdownButton]="cartPreview_26.dropdownButton"
                [placement]="cartPreview_26.placement"
                [triggerType]="cartPreview_26.triggerType"
              >
              </rappider-cart-preview>
            </div>

            <div class="rappider-component">
              <!-- Component: Icon 27 -->
              <rappider-icon
                [name]="icon_27.name"
                [color]="icon_27.color"
                [size]="icon_27.size"
                [type]="icon_27.type"
                [theme]="icon_27.theme"
                [animation]="icon_27.animation"
                [style]="icon_27.style"
                [secondColor]="icon_27.secondColor"
              >
              </rappider-icon>
            </div>
          </div>
        </div>

        <!-- Container: Container 17 -->
        <div
          class="rappider-container container-17 col-12 container-spacing-settings navbar-mobile-bg"
        >
          <div class="rappider-component">
            <!-- Component: Input Group 28 -->
            <rappider-input-group
              [prefixIcon]="inputGroup_28.prefixIcon"
              [suffixIcon]="inputGroup_28.suffixIcon"
              [prefixButton]="inputGroup_28.prefixButton"
              [suffixButton]="inputGroup_28.suffixButton"
              [textbox]="inputGroup_28.textbox"
              [prefixText]="inputGroup_28.prefixText"
              [suffixText]="inputGroup_28.suffixText"
            >
            </rappider-input-group>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div>
    <router-outlet></router-outlet>
  </div>

  <!-- Container: Container 18 -->
  <div class="rappider-container container-18 col-12">
    <!-- Container: Container 29 -->
    <div class="rappider-container container-29 col-12 px-0">
      <div class="rappider-component">
        <!-- Component: Divider 42 -->
        <rappider-divider
          [style]="divider_42.style"
          [type]="divider_42.type"
          [text]="divider_42.text"
          [textPlacement]="divider_42.textPlacement"
          [dividerWidth]="divider_42.dividerWidth"
          [dividerColor]="divider_42.dividerColor"
        >
        </rappider-divider>
      </div>
    </div>

    <!-- Container: Container 30 -->
    <div
      class="rappider-container container-30 col-10 container-width-100-mw480"
    >
      <!-- Container: Container 31 -->
      <div
        class="rappider-container container-31 col-2 footer-container-settings"
      >
        <div class="rappider-component">
          <!-- Component: Heading 43 -->
          <rappider-heading
            [content]="heading_43.content"
            [type]="heading_43.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 44 -->
          <rappider-button
            [text]="button_44.text"
            [type]="button_44.type"
            [shape]="button_44.shape"
            [size]="button_44.size"
            [colorType]="button_44.colorType"
            [icon]="button_44.icon"
            [iconPlacement]="button_44.iconPlacement"
            [transparent]="button_44.transparent"
            [loading]="button_44.loading"
            [block]="button_44.block"
            [disabled]="button_44.disabled"
            [key]="button_44.key"
            [emitWithoutPopconfirm]="button_44.emitWithoutPopconfirm"
            [popconfirmTitle]="button_44.popconfirmTitle"
            [borderSettings]="button_44.borderSettings"
            [marginSettings]="button_44.marginSettings"
            [paddingSettings]="button_44.paddingSettings"
            [shadowSettings]="button_44.shadowSettings"
            [customColorSettings]="button_44.customColorSettings"
            [customSizeSettings]="button_44.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 45 -->
          <rappider-button
            [text]="button_45.text"
            [type]="button_45.type"
            [shape]="button_45.shape"
            [size]="button_45.size"
            [colorType]="button_45.colorType"
            [icon]="button_45.icon"
            [iconPlacement]="button_45.iconPlacement"
            [transparent]="button_45.transparent"
            [loading]="button_45.loading"
            [block]="button_45.block"
            [disabled]="button_45.disabled"
            [key]="button_45.key"
            [emitWithoutPopconfirm]="button_45.emitWithoutPopconfirm"
            [popconfirmTitle]="button_45.popconfirmTitle"
            [borderSettings]="button_45.borderSettings"
            [marginSettings]="button_45.marginSettings"
            [paddingSettings]="button_45.paddingSettings"
            [shadowSettings]="button_45.shadowSettings"
            [customColorSettings]="button_45.customColorSettings"
            [customSizeSettings]="button_45.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 46 -->
          <rappider-button
            [text]="button_46.text"
            [type]="button_46.type"
            [shape]="button_46.shape"
            [size]="button_46.size"
            [colorType]="button_46.colorType"
            [icon]="button_46.icon"
            [iconPlacement]="button_46.iconPlacement"
            [transparent]="button_46.transparent"
            [loading]="button_46.loading"
            [block]="button_46.block"
            [disabled]="button_46.disabled"
            [key]="button_46.key"
            [emitWithoutPopconfirm]="button_46.emitWithoutPopconfirm"
            [popconfirmTitle]="button_46.popconfirmTitle"
            [borderSettings]="button_46.borderSettings"
            [marginSettings]="button_46.marginSettings"
            [paddingSettings]="button_46.paddingSettings"
            [shadowSettings]="button_46.shadowSettings"
            [customColorSettings]="button_46.customColorSettings"
            [customSizeSettings]="button_46.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 47 -->
          <rappider-button
            [text]="button_47.text"
            [type]="button_47.type"
            [shape]="button_47.shape"
            [size]="button_47.size"
            [colorType]="button_47.colorType"
            [icon]="button_47.icon"
            [iconPlacement]="button_47.iconPlacement"
            [transparent]="button_47.transparent"
            [loading]="button_47.loading"
            [block]="button_47.block"
            [disabled]="button_47.disabled"
            [key]="button_47.key"
            [emitWithoutPopconfirm]="button_47.emitWithoutPopconfirm"
            [popconfirmTitle]="button_47.popconfirmTitle"
            [borderSettings]="button_47.borderSettings"
            [marginSettings]="button_47.marginSettings"
            [paddingSettings]="button_47.paddingSettings"
            [shadowSettings]="button_47.shadowSettings"
            [customColorSettings]="button_47.customColorSettings"
            [customSizeSettings]="button_47.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 48 -->
          <rappider-button
            [text]="button_48.text"
            [type]="button_48.type"
            [shape]="button_48.shape"
            [size]="button_48.size"
            [colorType]="button_48.colorType"
            [icon]="button_48.icon"
            [iconPlacement]="button_48.iconPlacement"
            [transparent]="button_48.transparent"
            [loading]="button_48.loading"
            [block]="button_48.block"
            [disabled]="button_48.disabled"
            [key]="button_48.key"
            [emitWithoutPopconfirm]="button_48.emitWithoutPopconfirm"
            [popconfirmTitle]="button_48.popconfirmTitle"
            [borderSettings]="button_48.borderSettings"
            [marginSettings]="button_48.marginSettings"
            [paddingSettings]="button_48.paddingSettings"
            [shadowSettings]="button_48.shadowSettings"
            [customColorSettings]="button_48.customColorSettings"
            [customSizeSettings]="button_48.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>

      <!-- Container: Container 32 -->
      <div
        class="rappider-container container-32 col-2 footer-container-settings"
      >
        <div class="rappider-component">
          <!-- Component: Heading 49 -->
          <rappider-heading
            [content]="heading_49.content"
            [type]="heading_49.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 50 -->
          <rappider-button
            [text]="button_50.text"
            [type]="button_50.type"
            [shape]="button_50.shape"
            [size]="button_50.size"
            [colorType]="button_50.colorType"
            [icon]="button_50.icon"
            [iconPlacement]="button_50.iconPlacement"
            [transparent]="button_50.transparent"
            [loading]="button_50.loading"
            [block]="button_50.block"
            [disabled]="button_50.disabled"
            [key]="button_50.key"
            [emitWithoutPopconfirm]="button_50.emitWithoutPopconfirm"
            [popconfirmTitle]="button_50.popconfirmTitle"
            [borderSettings]="button_50.borderSettings"
            [marginSettings]="button_50.marginSettings"
            [paddingSettings]="button_50.paddingSettings"
            [shadowSettings]="button_50.shadowSettings"
            [customColorSettings]="button_50.customColorSettings"
            [customSizeSettings]="button_50.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 51 -->
          <rappider-button
            [text]="button_51.text"
            [type]="button_51.type"
            [shape]="button_51.shape"
            [size]="button_51.size"
            [colorType]="button_51.colorType"
            [icon]="button_51.icon"
            [iconPlacement]="button_51.iconPlacement"
            [transparent]="button_51.transparent"
            [loading]="button_51.loading"
            [block]="button_51.block"
            [disabled]="button_51.disabled"
            [key]="button_51.key"
            [emitWithoutPopconfirm]="button_51.emitWithoutPopconfirm"
            [popconfirmTitle]="button_51.popconfirmTitle"
            [borderSettings]="button_51.borderSettings"
            [marginSettings]="button_51.marginSettings"
            [paddingSettings]="button_51.paddingSettings"
            [shadowSettings]="button_51.shadowSettings"
            [customColorSettings]="button_51.customColorSettings"
            [customSizeSettings]="button_51.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 52 -->
          <rappider-button
            [text]="button_52.text"
            [type]="button_52.type"
            [shape]="button_52.shape"
            [size]="button_52.size"
            [colorType]="button_52.colorType"
            [icon]="button_52.icon"
            [iconPlacement]="button_52.iconPlacement"
            [transparent]="button_52.transparent"
            [loading]="button_52.loading"
            [block]="button_52.block"
            [disabled]="button_52.disabled"
            [key]="button_52.key"
            [emitWithoutPopconfirm]="button_52.emitWithoutPopconfirm"
            [popconfirmTitle]="button_52.popconfirmTitle"
            [borderSettings]="button_52.borderSettings"
            [marginSettings]="button_52.marginSettings"
            [paddingSettings]="button_52.paddingSettings"
            [shadowSettings]="button_52.shadowSettings"
            [customColorSettings]="button_52.customColorSettings"
            [customSizeSettings]="button_52.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 53 -->
          <rappider-button
            [text]="button_53.text"
            [type]="button_53.type"
            [shape]="button_53.shape"
            [size]="button_53.size"
            [colorType]="button_53.colorType"
            [icon]="button_53.icon"
            [iconPlacement]="button_53.iconPlacement"
            [transparent]="button_53.transparent"
            [loading]="button_53.loading"
            [block]="button_53.block"
            [disabled]="button_53.disabled"
            [key]="button_53.key"
            [emitWithoutPopconfirm]="button_53.emitWithoutPopconfirm"
            [popconfirmTitle]="button_53.popconfirmTitle"
            [borderSettings]="button_53.borderSettings"
            [marginSettings]="button_53.marginSettings"
            [paddingSettings]="button_53.paddingSettings"
            [shadowSettings]="button_53.shadowSettings"
            [customColorSettings]="button_53.customColorSettings"
            [customSizeSettings]="button_53.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>

      <!-- Container: Container 33 -->
      <div
        class="rappider-container container-33 col-2 footer-container-settings"
      >
        <div class="rappider-component">
          <!-- Component: Heading 54 -->
          <rappider-heading
            [content]="heading_54.content"
            [type]="heading_54.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 55 -->
          <rappider-button
            [text]="button_55.text"
            [type]="button_55.type"
            [shape]="button_55.shape"
            [size]="button_55.size"
            [colorType]="button_55.colorType"
            [icon]="button_55.icon"
            [iconPlacement]="button_55.iconPlacement"
            [transparent]="button_55.transparent"
            [loading]="button_55.loading"
            [block]="button_55.block"
            [disabled]="button_55.disabled"
            [key]="button_55.key"
            [emitWithoutPopconfirm]="button_55.emitWithoutPopconfirm"
            [popconfirmTitle]="button_55.popconfirmTitle"
            [borderSettings]="button_55.borderSettings"
            [marginSettings]="button_55.marginSettings"
            [paddingSettings]="button_55.paddingSettings"
            [shadowSettings]="button_55.shadowSettings"
            [customColorSettings]="button_55.customColorSettings"
            [customSizeSettings]="button_55.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 56 -->
          <rappider-button
            [text]="button_56.text"
            [type]="button_56.type"
            [shape]="button_56.shape"
            [size]="button_56.size"
            [colorType]="button_56.colorType"
            [icon]="button_56.icon"
            [iconPlacement]="button_56.iconPlacement"
            [transparent]="button_56.transparent"
            [loading]="button_56.loading"
            [block]="button_56.block"
            [disabled]="button_56.disabled"
            [key]="button_56.key"
            [emitWithoutPopconfirm]="button_56.emitWithoutPopconfirm"
            [popconfirmTitle]="button_56.popconfirmTitle"
            [borderSettings]="button_56.borderSettings"
            [marginSettings]="button_56.marginSettings"
            [paddingSettings]="button_56.paddingSettings"
            [shadowSettings]="button_56.shadowSettings"
            [customColorSettings]="button_56.customColorSettings"
            [customSizeSettings]="button_56.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 57 -->
          <rappider-button
            [text]="button_57.text"
            [type]="button_57.type"
            [shape]="button_57.shape"
            [size]="button_57.size"
            [colorType]="button_57.colorType"
            [icon]="button_57.icon"
            [iconPlacement]="button_57.iconPlacement"
            [transparent]="button_57.transparent"
            [loading]="button_57.loading"
            [block]="button_57.block"
            [disabled]="button_57.disabled"
            [key]="button_57.key"
            [emitWithoutPopconfirm]="button_57.emitWithoutPopconfirm"
            [popconfirmTitle]="button_57.popconfirmTitle"
            [borderSettings]="button_57.borderSettings"
            [marginSettings]="button_57.marginSettings"
            [paddingSettings]="button_57.paddingSettings"
            [shadowSettings]="button_57.shadowSettings"
            [customColorSettings]="button_57.customColorSettings"
            [customSizeSettings]="button_57.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 58 -->
          <rappider-button
            [text]="button_58.text"
            [type]="button_58.type"
            [shape]="button_58.shape"
            [size]="button_58.size"
            [colorType]="button_58.colorType"
            [icon]="button_58.icon"
            [iconPlacement]="button_58.iconPlacement"
            [transparent]="button_58.transparent"
            [loading]="button_58.loading"
            [block]="button_58.block"
            [disabled]="button_58.disabled"
            [key]="button_58.key"
            [emitWithoutPopconfirm]="button_58.emitWithoutPopconfirm"
            [popconfirmTitle]="button_58.popconfirmTitle"
            [borderSettings]="button_58.borderSettings"
            [marginSettings]="button_58.marginSettings"
            [paddingSettings]="button_58.paddingSettings"
            [shadowSettings]="button_58.shadowSettings"
            [customColorSettings]="button_58.customColorSettings"
            [customSizeSettings]="button_58.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>

      <!-- Container: Container 34 -->
      <div
        class="rappider-container container-34 col-3 container-width-100-mw480"
      >
        <div class="rappider-component">
          <!-- Component: Textbox 59 -->
          <rappider-textbox
            [placeholder]="textbox_59.placeholder"
            [type]="textbox_59.type"
            [mask]="textbox_59.mask"
            [maskGuide]="textbox_59.maskGuide"
            [cssStyle]="textbox_59.cssStyle"
            [cssClass]="textbox_59.cssClass"
            [disabled]="textbox_59.disabled"
            [mentionSupported]="textbox_59.mentionSupported"
            [mentionPrefix]="textbox_59.mentionPrefix"
            [mentionValues]="textbox_59.mentionValues"
            [borderSettings]="textbox_59.borderSettings"
            [sizeSettings]="textbox_59.sizeSettings"
            [colorSettings]="textbox_59.colorSettings"
            [boxShadowSettings]="textbox_59.boxShadowSettings"
            [paddingSettings]="textbox_59.paddingSettings"
            [marginSettings]="textbox_59.marginSettings"
            [size]="textbox_59.size"
          >
          </rappider-textbox>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 60 -->
          <rappider-button
            [text]="button_60.text"
            [type]="button_60.type"
            [shape]="button_60.shape"
            [size]="button_60.size"
            [colorType]="button_60.colorType"
            [icon]="button_60.icon"
            [iconPlacement]="button_60.iconPlacement"
            [transparent]="button_60.transparent"
            [loading]="button_60.loading"
            [block]="button_60.block"
            [disabled]="button_60.disabled"
            [key]="button_60.key"
            [emitWithoutPopconfirm]="button_60.emitWithoutPopconfirm"
            [popconfirmTitle]="button_60.popconfirmTitle"
            [borderSettings]="button_60.borderSettings"
            [marginSettings]="button_60.marginSettings"
            [paddingSettings]="button_60.paddingSettings"
            [shadowSettings]="button_60.shadowSettings"
            [customColorSettings]="button_60.customColorSettings"
            [customSizeSettings]="button_60.customSizeSettings"
          >
          </rappider-button>
        </div>

        <!-- Container: Container 35 -->
        <div
          class="rappider-container container-35 col-8 container-width-100-mw480"
        >
          <div class="rappider-component">
            <!-- Component: Icon 61 -->
            <rappider-icon
              [name]="icon_61.name"
              [color]="icon_61.color"
              [size]="icon_61.size"
              [type]="icon_61.type"
              [theme]="icon_61.theme"
              [animation]="icon_61.animation"
              [style]="icon_61.style"
              [secondColor]="icon_61.secondColor"
            >
            </rappider-icon>
          </div>

          <div class="rappider-component">
            <!-- Component: Icon 62 -->
            <rappider-icon
              [name]="icon_62.name"
              [color]="icon_62.color"
              [size]="icon_62.size"
              [type]="icon_62.type"
              [theme]="icon_62.theme"
              [animation]="icon_62.animation"
              [style]="icon_62.style"
              [secondColor]="icon_62.secondColor"
            >
            </rappider-icon>
          </div>

          <div class="rappider-component">
            <!-- Component: Icon 63 -->
            <rappider-icon
              [name]="icon_63.name"
              [color]="icon_63.color"
              [size]="icon_63.size"
              [type]="icon_63.type"
              [theme]="icon_63.theme"
              [animation]="icon_63.animation"
              [style]="icon_63.style"
              [secondColor]="icon_63.secondColor"
            >
            </rappider-icon>
          </div>

          <div class="rappider-component">
            <!-- Component: Icon 64 -->
            <rappider-icon
              [name]="icon_64.name"
              [color]="icon_64.color"
              [size]="icon_64.size"
              [type]="icon_64.type"
              [theme]="icon_64.theme"
              [animation]="icon_64.animation"
              [style]="icon_64.style"
              [secondColor]="icon_64.secondColor"
            >
            </rappider-icon>
          </div>
        </div>
      </div>
    </div>

    <!-- Container: Container 36 -->
    <div class="rappider-container container-36 col-10">
      <!-- Container: Container 37 -->
      <div class="rappider-container container-37 col-6">
        <div class="rappider-component">
          <!-- Component: Text 65 -->
          <rappider-text
            [textMode]="text_65.textMode"
            [text]="text_65.text"
            [content]="text_65.content"
            [typography]="text_65.typography"
            [colorSettings]="text_65.colorSettings"
          >
          </rappider-text>
        </div>
      </div>

      <!-- Container: Container 38 -->
      <div class="rappider-container container-38 col-6">
        <div class="rappider-component">
          <!-- Component: Text 66 -->
          <rappider-text
            [textMode]="text_66.textMode"
            [text]="text_66.text"
            [content]="text_66.content"
            [typography]="text_66.typography"
            [colorSettings]="text_66.colorSettings"
          >
          </rappider-text>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 67 -->
          <rappider-image
            [source]="image_67.source"
            [alternateText]="image_67.alternateText"
            [placeholder]="image_67.placeholder"
            [disablePreview]="image_67.disablePreview"
            [borderSettings]="image_67.borderSettings"
            [shadowSettings]="image_67.shadowSettings"
            [paddingSettings]="image_67.paddingSettings"
            [marginSettings]="image_67.marginSettings"
            [customSizeSettings]="image_67.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 68 -->
          <rappider-image
            [source]="image_68.source"
            [alternateText]="image_68.alternateText"
            [placeholder]="image_68.placeholder"
            [disablePreview]="image_68.disablePreview"
            [borderSettings]="image_68.borderSettings"
            [shadowSettings]="image_68.shadowSettings"
            [paddingSettings]="image_68.paddingSettings"
            [marginSettings]="image_68.marginSettings"
            [customSizeSettings]="image_68.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 69 -->
          <rappider-image
            [source]="image_69.source"
            [alternateText]="image_69.alternateText"
            [placeholder]="image_69.placeholder"
            [disablePreview]="image_69.disablePreview"
            [borderSettings]="image_69.borderSettings"
            [shadowSettings]="image_69.shadowSettings"
            [paddingSettings]="image_69.paddingSettings"
            [marginSettings]="image_69.marginSettings"
            [customSizeSettings]="image_69.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 70 -->
          <rappider-image
            [source]="image_70.source"
            [alternateText]="image_70.alternateText"
            [placeholder]="image_70.placeholder"
            [disablePreview]="image_70.disablePreview"
            [borderSettings]="image_70.borderSettings"
            [shadowSettings]="image_70.shadowSettings"
            [paddingSettings]="image_70.paddingSettings"
            [marginSettings]="image_70.marginSettings"
            [customSizeSettings]="image_70.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 71 -->
          <rappider-image
            [source]="image_71.source"
            [alternateText]="image_71.alternateText"
            [placeholder]="image_71.placeholder"
            [disablePreview]="image_71.disablePreview"
            [borderSettings]="image_71.borderSettings"
            [shadowSettings]="image_71.shadowSettings"
            [paddingSettings]="image_71.paddingSettings"
            [marginSettings]="image_71.marginSettings"
            [customSizeSettings]="image_71.customSizeSettings"
          >
          </rappider-image>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__footer__end -->

<!-- #endregion customCode: page-component-html__footer__end -->
